import React from 'react';
import clsx from 'clsx';
import { Typography } from '@/components/common';

interface Props {
	status: string;
	classname?: string;
	classNameText?: string;
}

export const DocumentBadge: React.FC<Props> = ({
	classNameText,
	classname,
	status: currentStatus,
}) => {
	const status = currentStatus?.toLowerCase();
	if (!status) return <></>;
	return (
		<div
			className={clsx(
				'rounded-xl px-2 py-1 flex items-center justify-center h-[22px] bg-[#6E6A7326]',
				{
					'!bg-green-secondary': status === 'validated',
					'!bg-[#EB35CE14]': status === 'incomplete',
					'!bg-[#FF004314]': status === 'invalid',
					'!bg-[#2D41F50D]': status === 'signed',
					'!bg-yellow-base/20': status === 'pending',
				},
				classname
			)}
		>
			<Typography
				type="semibold-12"
				className={clsx(
					'capitalize text-gray-35',
					{
						'!text-green-60': status === 'validated',
						'!text-main-magenta': status === 'incomplete',
						'!text-main-red': status === 'invalid',
						'!text-main-blue-dark': status === 'signed',
						'!text-yellow-base': status === 'pending',
					},
					classNameText
				)}
			>
				{status}
			</Typography>
		</div>
	);
};
